module.exports = __webpack_public_path__ + "static/media/sweetdreamsbooth.1efcdb70.jpg";